export const SET_FORM_DATA_TOKOPEDIA = "SET_FORM_DATA_TOKOPEDIA";

export const setFormDataTokopedia = data => ({
  type: SET_FORM_DATA_TOKOPEDIA,
  payload: { data },
});
